import { render, staticRenderFns } from "./role-manage.vue?vue&type=template&id=09c5ae78&scoped=true"
import script from "./role-manage.vue?vue&type=script&lang=js"
export * from "./role-manage.vue?vue&type=script&lang=js"
import style0 from "./role-manage.vue?vue&type=style&index=0&id=09c5ae78&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c5ae78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09c5ae78')) {
      api.createRecord('09c5ae78', component.options)
    } else {
      api.reload('09c5ae78', component.options)
    }
    module.hot.accept("./role-manage.vue?vue&type=template&id=09c5ae78&scoped=true", function () {
      api.rerender('09c5ae78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/user-manage/role-manage.vue"
export default component.exports